export const isNotGoBack = ["/auth", "/dashboard", "/payment_success"];

export const isNotGoBackDesk = ["/auth", "/dashboard", "/payment_success"];

export const isSelfie = ["/dashboard", "/payment_success", "/terms", "/policy"];
